import _ from 'lodash';
import Vue from 'vue';
import {mapActions, mapState, mapGetters} from 'vuex';
import {helpers, url} from 'vuelidate/lib/validators';
import EventHub from '../../lib/eventHub';
import {AxiosResponse} from 'axios';
import BioConfigService from '../../lib/services/bioConfigService';
import {AlertNotificationModuleConstant, BioProfileModuleConstant, BioServicesConstant, EmployeeProfileModuleConstant, EventConstant, RoleConfigs, UrlModuleConstant} from '../../lib/constants';
import Social from './edit-social.html';
import BioAdmin from 'types/ba/bioAdmin';

interface IComponentData {
	bioProfileServiceLoading: boolean;
	socialLinks: object[];
	roles: string[];
	biosConfigResponse: BioAdmin.IBiosConfigResponse;
	roleFeatures: string[];
	form: BioAdmin.ISocialFormValidator;
}

const bioConfigService: BioAdmin.IBioConfigService = new BioConfigService();
const spotifyValidate = helpers.regex('spotifyValidate', BioServicesConstant.spotifyPlaylistUrlRegex);
const instagramValidate = helpers.regex('instagramValidate', BioServicesConstant.instagramUrlRegex);
const facebookValidate = helpers.regex('facebookValidate', BioServicesConstant.facebookUrlRegex);
const tiktokValidate = helpers.regex('tiktokValidate', BioServicesConstant.tiktokUrlRegex);
const twitterValidate = helpers.regex('twitterValidate', BioServicesConstant.twitterUrlRegex);
const youtubeValidate = helpers.regex('youtubeValidate', BioServicesConstant.youtubeUrlRegex);

export default Vue.component('social', {
	template: Social,
	data(): IComponentData {
		return {
			bioProfileServiceLoading: true,
			socialLinks: [],
			roles: [],
			biosConfigResponse:  {
				rolesFeatures: [
					{
						roleId: 1,
						roleName : 'Personal Trainer',
						features: [
							'contact',
							'quote'
						]
					}],
				features:
				{
					quote: {
						maxLength: '50',
					},
					contact: {}
				}
			},
			roleFeatures: [],
			form: {
				spotify: '',
				instagram: '',
				facebook: '',
				tiktok: '',
				twitter: '',
				youtube: '',
			},
		};
	},
	computed: {
		...mapState(BioProfileModuleConstant.name, [
			'bioProfile',
		]),
		...mapGetters(BioProfileModuleConstant.name, {
			getSocialUrl: BioProfileModuleConstant.getter.getSocialUrl,
		}),
		...mapGetters(UrlModuleConstant.name, {
			getUrlParameter: UrlModuleConstant.getter.getUrlParameter,
		}),
	},
	methods: {
		...mapActions(AlertNotificationModuleConstant.name, {
			synchronizeAlertNotificationStore: AlertNotificationModuleConstant.action.synchronize,
		}),
		...mapActions(EmployeeProfileModuleConstant.name, {
			synchronizeEmployeeProfileStore: EmployeeProfileModuleConstant.action.synchronize,
		}),
		...mapActions(UrlModuleConstant.name, {
			synchronizeUrlStore: UrlModuleConstant.action.synchronize,
		}),
		...mapActions(BioProfileModuleConstant.name, {
			getProfile: BioProfileModuleConstant.action.getProfile,
			updateProfileSocialLink: BioProfileModuleConstant.action.updateProfileSocialLink,
		}),
		getRoleConfig() {
			return bioConfigService.getRoleConfig()
				.then((response: AxiosResponse<BioAdmin.IBiosConfigResponse>) => {
					this.biosConfigResponse = response.data;
				}).catch((error) => {
					// use config constant on localhost
					this.biosConfigResponse = RoleConfigs;
				});
		},
		hasFeature(feature: string): boolean {
			return this.roleFeatures.includes(feature);
		},
		hasRole(role: string): boolean {
			return this.roles.includes(role);
		},
		setFeaturesByRole() {
			this.roles = [];
			this.roleFeatures = [];
			// @ts-ignore
			_.forEach(this.bioProfile.roles, (profileRole: BioAdmin.IRole) => {
				const validRole: any = _.find(this.biosConfigResponse.rolesFeatures, (rc) => {
					return profileRole.name === rc.roleName;
				});
				this.roles.push(validRole.roleName);
				_.forEach(validRole.features, (feature) => {
					if (!this.roleFeatures.includes(feature)) {
						this.roleFeatures.push(feature);
					}
				});
			});
		},
	},
	watch: {

	},
	created(): void {
		EventHub.$on(EventConstant.BioProfileServiceLoading, (loading: boolean) => {
			this.bioProfileServiceLoading = loading;
		});

		Promise.all([this.synchronizeAlertNotificationStore(), this.synchronizeEmployeeProfileStore(), this.synchronizeUrlStore(), this.getRoleConfig()]).then(() => {
			this.getProfile().then(() => {
				this.setFeaturesByRole();
				this.form = {
					spotify: this.getSocialUrl('spotify'),
					instagram: this.getSocialUrl('instagram'),
					facebook: this.getSocialUrl('facebook'),
					tiktok: this.getSocialUrl('tiktok'),
					twitter: this.getSocialUrl('twitter'),
					youtube: this.getSocialUrl('youtube'),
				};
			});
		});
	},
	validations: {
		form: {
			spotify: {
				url,
				spotifyValidate,
			},
			instagram: {
				url,
				instagramValidate,
			},
			facebook: {
				url,
				facebookValidate,
			},
			tiktok: {
				url,
				tiktokValidate,
			},
			twitter: {
				url,
				twitterValidate,
			},
			youtube: {
				url,
				youtubeValidate,
			},
		},
	},
});
